<template>
  <div v-if="show">

    <weex-text
      class="margin-right-10 margin-left-10 margin_top_20 font-size-base text-align-center"
      v-html="callAndVerifyMessage"
      ></weex-text>

    <weex-text class="margin_top_20 font-size-base font-weight-bold text-align-center">
      {{otp}}
    </weex-text>

    <wxc-button
      :text="loginText"
      class="horizontal_center margin-top-30"
      type="blue"
      @wxcButtonClicked="onLoginClicked"
      ></wxc-button>

    <div v-if="showSMSOTPOption">
      <weex-text
        class="margin-top-10 text-align-center font-weight-bold text-color-gray">
        -OR-
      </weex-text>

      <wxc-button
        :text="smsOtpOptionText"
        class="horizontal_center margin-top-10"
        type="blue"
        @wxcButtonClicked="onVerifyWithSMSOTPClicked"
        ></wxc-button>
    </div>
  </div>
</template>

<script>

  import WxcButton from "../../../weex-ui/packages/wxc-button/index";

  export default {
    name: 'CallAndVerifyView',
    components: { WxcButton },

    props: {
      show: {
        type: Boolean,
        required: true,
        default: false
      },

      showSMSOTPOption: {
        type: Boolean,
        default: true
      },

      callAndVerifyMessage: {
        type: String,
        required: true
      },

      otp: {
        type: String,
        required: true
      },

      loginText: {
        type: String,
        default: "Login"
      },

      smsOtpOptionText: {
        type: String,
        default: "Verify with SMS OTP"
      }
    },

    methods: {
      onLoginClicked() {
        this.$emit("onLoginClicked")
      },

      onVerifyWithSMSOTPClicked() {
        this.$emit("onVerifyWithSMSOTPClicked")
      }
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
